var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglassFlip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2892",
    d: "M0-682.665H14v14H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40526",
    "data-name": "Group 40526",
    transform: "translate(11085 18485)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15351",
    "data-name": "Rectangle 15351",
    width: 16,
    height: 16,
    transform: "translate(-11085 -18485)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2886",
    transform: "translate(-11084 -17801.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2888",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2890",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2896",
    transform: "translate(3.316 0.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2898",
    d: "M0,0V1.584C0,4.819,3.684,6.59,3.684,6.59S7.369,4.819,7.369,1.584V0Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2900",
    transform: "translate(3.316 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2902",
    d: "M-175.971,0s-3.684,1.771-3.684,5.006V6.59h7.369V5.006C-172.287,1.771-175.971,0-175.971,0Z",
    transform: "translate(179.656)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2904",
    transform: "translate(2.324 0.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2906",
    d: "M-47.368,0h-.992",
    transform: "translate(48.36 0)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2908",
    transform: "translate(10.684 0.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2910",
    d: "M0,0H.992",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2912",
    transform: "translate(2.324 13.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2914",
    d: "M-47.368,0h-.992",
    transform: "translate(48.36 0)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2916",
    transform: "translate(10.684 13.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2918",
    d: "M0,0H.992",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2920",
    transform: "translate(3.72 3.804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2922",
    d: "M0,0H6.517",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2924",
    transform: "translate(3.316 10.953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2926",
    d: "M-79.3-41.412l-1.66,1.769h7.326l-1.66-1.769A2.746,2.746,0,0,0-79.3-41.412Z",
    transform: "translate(80.96 42.279)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassFlip);
export default __webpack_public_path__ + "static/media/hourglass-flip.fc7747b5befee3f0b5ce5eee43e7e466.svg";
export { ForwardRef as ReactComponent };